import {
  ControlledDateSelect,
  ControlledInput,
} from '@uikit/FormItems/ControlledItems';
import Modal from '@uikit/Modal/Modal';
import { validations } from '@utils/validations';
import React, { FC } from 'react';
import TableSection from '@uikit/Tables/TableSection/TableSection';
import { useRideSearch } from '@hooks/useRideSearch';

interface IRideSearchModal {
  closeModal: () => void;
}

const RideSearchModal: FC<IRideSearchModal> = ({ closeModal }) => {
  const { control, searchRideData, isLoading, filters, handleClickEdit } =
    useRideSearch();

  return (
    <>
      <Modal
        title="Ride Search"
        closeClick={closeModal}
        maxWidth="980px"
        dataTestId="rsm"
      >
        <div className="search-wrapper ride-search-wrapper" data-test-id="rsm">
          <div
            className="modal-search-from ride-search-inputs-wrapper"
            data-test-id="rsm-form"
          >
            <div className="first-row" data-test-id="rsm-row1">
              <div className="modal-search-item">
                <ControlledDateSelect
                  control={control}
                  name="dateFrom"
                  title="Date Of Service  Start"
                  dataTestId="rsm-from"
                />
              </div>
              <div className="modal-search-item">
                <ControlledDateSelect
                  control={control}
                  name="dateTo"
                  title="Date Of Service  End"
                  dataTestId="rsm-to"
                />
              </div>
              <div className="modal-search-item">
                <ControlledInput
                  control={control}
                  name="confirmationCode"
                  title="Confirmation Code"
                  dataTestId="rsm-cc"
                />
              </div>

              <div className="modal-search-item">
                <ControlledInput
                  name="authorizationNumber"
                  control={control}
                  title="Authorization Number"
                  type="alphanumeric"
                  dataTestId="rsm-auth"
                />
              </div>
            </div>
            <div className="second-row" data-test-id="rsm-row2">
              <div className="modal-search-item">
                <ControlledInput
                  control={control}
                  name="memberId"
                  title="Member ID"
                  dataTestId="rsm-mid"
                />
              </div>
              <div className="modal-search-item">
                <ControlledInput
                  name="primaryContactNumber"
                  mask="(999) 999-9999"
                  title="Contact Number"
                  control={control}
                  rules={{
                    validate: {
                      exactLength: (value) =>
                        validations.length('Primary Contact Number', value, 10),
                    },
                  }}
                  dataTestId="rsm-phone"
                />
              </div>
              <div className="modal-search-item">
                <ControlledInput
                  name="memberFirstName"
                  title="Member First Name"
                  control={control}
                  dataTestId="rsm-fn"
                />
              </div>

              <div className="modal-search-item">
                <ControlledInput
                  name="memberLastName"
                  title="Member Last Name"
                  control={control}
                  dataTestId="rsm-ln"
                />
              </div>
            </div>
          </div>

          {[
            {
              ...searchRideData,
              title: 'Search Result',
              isLoading: isLoading,
              argument: { body: filters },
            },
          ].map((config) => (
            <TableSection
              dataTestId={`rsm-res-${config.title}`}
              key={config.title}
              title={config.title}
              isLoading={config.isLoading}
              openModal={config.openModal}
              permissions={config.permissions}
              requestTablePageChange={config.requestTablePageChange}
              tableCustomClassName={[
                'ride-search-results-table',
                config.tableCustomClassName,
              ]
                .filter(Boolean)
                .join(' ')}
              hasCreatePermission={false}
              showTable={true}
              tableName={config.table}
              sortBy={config.sortBy}
              sortDir={config.sortDir}
              onEditClick={config.handleEditClick}
              rows={config.rows}
              page={config.page}
              columns={config.columns}
              totalElements={config.totalElements}
              size={config.size}
              totalPages={config.totalPages}
              modalName={config.modalName}
              addBtnTitle={config.addBtnTitle}
              argument={config.argument}
              isFilterable={false}
              arrowIconMember={true}
              handleSelectedRow={handleClickEdit}
              infiniteScroll={true}
              infiniteScrollThreshold={0.9}
            />
          ))}
        </div>
      </Modal>
    </>
  );
};

export default RideSearchModal;
